import { StatusConfig as BaseStatusConfig } from "../types";

export enum RefreshStatus {
  RefreshRequired = "refresh_required",
  UpcomingRefresh = "upcoming_refresh",
  RequestSent = "request_sent",
  RequestSentOverdue = "request_sent_overdue",
  LpRequestInProgress = "lp_request_in_progress",
  PendingReview = "pending_review",
  InProgress = "in_progress",
  InReview = "in_review",
  NoUpcomingRefresh = "no_upcoming_refresh",
  NotRequired = "not_required",
  NoSchedule = "no_schedule",
  PendingFundReview = "pending_fund_review",
  Ready = "ready",
  UnderReview = "under_review",
  Closed = "closed",
}

export const REFRESH_STATUSES_WITH_CASE_LINK = [
  RefreshStatus.Ready,
  RefreshStatus.InProgress,
  RefreshStatus.PendingReview,
  RefreshStatus.PendingFundReview,
  RefreshStatus.InReview,
  RefreshStatus.LpRequestInProgress,
];

export type RefreshStatusCellRendererProps = {
  value: RefreshStatus | null;
  data?: {
    id?: number;
    name?: string;
    profileGuid?: string;
    isEntityClientOnboardingProfile?: boolean;
    refreshCaseId?: number;
    invitationId?: number;
    tooltipData?: {
      nextRefreshDueDate?: Date;
      requestSentDate?: Date;
      requestSentCount?: number;
    };
  };
};

export type StatusConfig = BaseStatusConfig<RefreshStatusCellRendererProps["data"]>;
